import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { headColor } from '../../dashBoard/businessAnalysis'
export const RenderTable = (props) => {
  const { data, key1, key2, key3, headerFontSize = '16px', bodyFontSize = '14px', tableStyle, headcolStyle, datacolStyle, showHeader = true } = props
  let { header } = props
  header = header?.map((item) => {
    return {
      ...item,
      align: item.align ? item.align : item?.xlCol?.dataType === "quantity" ? 'right' : undefined,
    }
  })
  return (
    <Table size="small" aria-label="a dense table" style={{ marginBottom: '20px', ...tableStyle }}>
      <TableHead style={{ position: `sticky`, top: `0`,zIndex:1, background: `white`, display: showHeader ? undefined : 'none' }}>
        <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
          {header.map((item, i) => (
            <TableCell
              key={key1 + i}
              style={{ textAlign: item.align, color: '#444444', backgroundColor: headColor.header, fontSize: headerFontSize, fontWeight: 600, width: item?.width, ...headcolStyle }}
            >
              {item.headerName}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      {data.length ? (
        <TableBody className="filter-data-row" style={{ border: 'none' }}>
          {data.map((row, index) => (
            <TableRow className="receivedTr" key={key2 + index}>
              {(() => {
                let skip = 0;

                return header.map((item, i, { length }) => {
                  const isLastIndex = i + 1 === length;
                  if (skip > 0) {
                    skip--;
                    return <></>;
                  }
                  const colSpan = row.colSpan?.[item.field] || 1;
                  skip = colSpan - 1;

                  return (
                    <TableCell
                      key={key3 + i}
                      colSpan={colSpan}
                      className={row.dataType}
                      style={{
                        textAlign: row.align?.[item.field]===undefined?colSpan > 1 ? 'left' : item.align:row.align?.[item.field],
                        color: isLastIndex && ['entry','total'].includes(row.dataType) ? '#0086ff' : '#444444',
                        backgroundColor: headColor[row.dataType],
                        fontSize: bodyFontSize,
                        fontWeight: 500,
                        top: row?.top,
                        ...datacolStyle
                      }}
                    >
                      {row[item.field]}
                    </TableCell>
                  )
                });
              })()}
            </TableRow>
          ))}
        </TableBody>
      ) : (
        <>
          <TableBody>
            <TableRow>
              <TableCell colSpan={header.length}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '20px',
                    marginBottom: '20px',
                    color: 'red',
                    fontSize: bodyFontSize,
                  }}
                >
                  <span>No results found. Please refine your search parameters and search again.</span>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </>
      )}
    </Table>
  )
}
